module.exports = __webpack_public_path__ + "img/step2-mobile-en.039b7b69.webp";